import classNames from "classnames";
import { getLoanNavStatusDisplay, LoanNavBaseState } from "./loanNavStatusMapping";
import "./loan-status-chip.scss";

export interface LoanStatusChipProps {
  readonly baseState: LoanNavBaseState;
  readonly className?: string;
}

export default function LoanStatusChip({ baseState, className }: LoanStatusChipProps) {
  const { label, variant } = getLoanNavStatusDisplay(baseState);

  return (
    <span className={classNames("loan-status-chip", `loan-status-chip--${variant}`, className)}>
      {label}
    </span>
  );
}
